import CrmPropertiesProvider from './CrmPropertiesProvider';

let def: any =
{
	__init__:
	[
		'propertiesProvider'
	],
	propertiesProvider: [ 'type', CrmPropertiesProvider ]
};

export default def;
